export default "__VITE_ASSET__37a7ef99__"